import React from "react";
import { HashRouter } from "react-router-dom";
import Layout from "./Layout";
import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer } from "react-toastify";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { UsuarioProvider, useUsuario } from "./context/usuario-context";

// PAGES
import Loader from "./pages/Loader";
import Login from "./components/Login";
import Video from "./components/Video";
import Router from "./router";
// PAGES

const theme = createTheme({
  modal:{
    overflow:'auto',
  },
  palette: {
    background: {
      default: "#136fb9",
    },
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
  },
  root: {
    "& .MuiInputLabel-root": {
      color: "#000 !important",
    },
  },
});

const AppExport = () => (
  <UsuarioProvider>
    <App />
  </UsuarioProvider>
);

function App() {
  const { dataUser, loadUser, loadConfig } = useUsuario();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        {loadUser || loadConfig ? (
          <Loader />
        ) : !dataUser ? (
          <>
            <Login />
            <Video />
          </>
        ) : (
          <HashRouter>
            <Router />
          </HashRouter>
        )}
      </Layout>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </ThemeProvider>
  );
}

export default AppExport;
